/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SentInputs */

const cs_enum_sent = /** @type {(inputs: Enum_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odesláno`)
};

const en_enum_sent = /** @type {(inputs: Enum_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent`)
};

/**
* | output |
* | --- |
* | "Sent" |
*
* @param {Enum_SentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_sent = /** @type {((inputs?: Enum_SentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_sent(inputs)
	return cs_enum_sent(inputs)
});